import React from "react";
import PropTypes from "prop-types";

import './Loading.scss';

export default function Spinner({ width = "2rem", height = "2rem", color = "#fa86ac" }) {
  return (
    <div className="spinnerWrapper">
      <div
        className="spinnerBorder"
        role="status"
        style={{ "--spinner-color": color, "--spinner-width": width, "--spinner-height": height }}
      ></div>
    </div>
  );
};

Spinner.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
};